<template>
  <div class="section prachtwild is-clipped">
    <div class="container">
      <div class="columns is-mobile is-gapless">
        <div
          class="column is-8-mobile is-6-tablet is-6-desktop is-5-widescreen is-5-fullhd textcolumn"
        >
          <p
            class="title is-1 is-size-2-mobile has-text-white spacetop heroshout"
          >
            {{ question }}
          </p>

          <div
            class="subtitle is-1 is-size-4-mobile has-text-white is-clearfix"
          >
            <b-carousel
              animated="slide"
              :pause-info="false"
              :arrow="false"
              :arrow-hover="false"
              :indicator="false"
            >
              <b-carousel-item v-for="(question, i) in questions" :key="i">
                {{ question.text }}
              </b-carousel-item>
            </b-carousel>
            <span class="questionmark"
              ><svg
                viewBox="0 0 128 248"
                xmlns="http://www.w3.org/2000/svg"
                fill-rule="evenodd"
                clip-rule="evenodd"
                stroke-linejoin="round"
                stroke-miterlimit="2"
              >
                <path
                  d="M18.761 0C53.76 1.444 80.458 7.216 99.22 17.68c18.762 10.463 28.142 24.534 28.142 42.574 0 10.463-2.886 19.843-9.02 28.863-6.494 9.02-15.153 16.597-26.699 22.73l-20.926 10.824-1.082 2.165 2.525 25.617-49.068 7.216-4.69-4.33-4.69-45.46 2.164-3.969 30.307-11.906C57.728 87.314 63.5 80.097 63.5 71.077c0-6.855-4.33-11.906-12.628-15.153s-23.812-5.773-45.82-7.216L0 42.214 12.628 3.248 18.76 0zm31.75 175.709c10.464 0 18.762 2.886 24.896 9.02 5.772 6.133 8.659 14.431 8.659 25.255 0 11.546-3.247 20.566-9.742 27.42-6.494 6.856-15.514 10.103-26.699 10.103-11.184 0-19.483-2.886-25.256-9.02-5.772-5.773-8.659-14.07-8.659-25.256 0-11.545 3.247-20.565 10.103-27.42 6.494-6.855 15.514-10.102 26.699-10.102z"
                  fill-rule="nonzero"
                /></svg
            ></span>
          </div>
          <p class="subtitle is-4 is-size-5-mobile has-text-info claimbox">
            {{ claim }}
          </p>
          <p class="is-size-5 is-size-6-mobile has-text-white spacebottom">
            {{ solution }}
          </p>
        </div>
        <div
          class="column is-5-mobile is-9-tablet is-8-desktop is-7-widescreen is-5-fullhd picturecolumn"
        >
          <figure class="image heroimage">
            <picture>
              <source
                media="(max-width: 768px)"
                sizes="
                  (max-width: 380px) 150px,
                  (min-width: 520px) 200px,
                  (min-width: 768px) 300px,
                  100vw
                "
                srcset="
                  ../assets/images/Biene-auf-Blume-v2-100.png 100w,
                  ../assets/images/Biene-auf-Blume-v2-150.png 150w,
                  ../assets/images/Biene-auf-Blume-v2-200.png 200w,
                  ../assets/images/Biene-auf-Blume-v2-250.png 250w,
                  ../assets/images/Biene-auf-Blume-v2-300.png 300w,
                  ../assets/images/Biene-auf-Blume-v2-350.png 350w,
                  ../assets/images/Biene-auf-Blume-v2-400.png 400w,
                  ../assets/images/Biene-auf-Blume-v2-500.png 500w,
                  ../assets/images/Biene-auf-Blume-v2-600.png 600w,
                  ../assets/images/Biene-auf-Blume-v2-700.png 700w
                "
              />
              <source
                media="(min-width: 769px"
                sizes="
                  (min-width: 769px) 750px,
                  (min-width: 1024px) 650px,
                  (min-width: 1216px) 670px,
                  (min-width: 1407px) 600px,
                  100vw
                "
                srcset="
                  ../assets/images/Biene-auf-Blume-v1-500.png   500w,
                  ../assets/images/Biene-auf-Blume-v1-560.png   560w,
                  ../assets/images/Biene-auf-Blume-v1-620.png   620w,
                  ../assets/images/Biene-auf-Blume-v1-680.png   680w,
                  ../assets/images/Biene-auf-Blume-v1-740.png   740w,
                  ../assets/images/Biene-auf-Blume-v1-800.png   800w,
                  ../assets/images/Biene-auf-Blume-v1-860.png   860w,
                  ../assets/images/Biene-auf-Blume-v1-920.png   920w,
                  ../assets/images/Biene-auf-Blume-v1-980.png   980w,
                  ../assets/images/Biene-auf-Blume-v1-1040.png 1040w
                "
              />
              <img
                sizes="(max-width: 7500px) 40vw, 3000px"
                srcset="
                  ../assets/images/Biene-auf-Blume-v2-100.png   100w,
                  ../assets/images/Biene-auf-Blume-v2-150.png   150w,
                  ../assets/images/Biene-auf-Blume-v2-200.png   200w,
                  ../assets/images/Biene-auf-Blume-v2-250.png   250w,
                  ../assets/images/Biene-auf-Blume-v2-300.png   300w,
                  ../assets/images/Biene-auf-Blume-v2-350.png   350w,
                  ../assets/images/Biene-auf-Blume-v2-400.png   400w,
                  ../assets/images/Biene-auf-Blume-v1-500.png   500w,
                  ../assets/images/Biene-auf-Blume-v1-560.png   560w,
                  ../assets/images/Biene-auf-Blume-v1-620.png   620w,
                  ../assets/images/Biene-auf-Blume-v1-680.png   680w,
                  ../assets/images/Biene-auf-Blume-v1-740.png   740w,
                  ../assets/images/Biene-auf-Blume-v1-800.png   800w,
                  ../assets/images/Biene-auf-Blume-v1-860.png   860w,
                  ../assets/images/Biene-auf-Blume-v1-920.png   920w,
                  ../assets/images/Biene-auf-Blume-v1-980.png   980w,
                  ../assets/images/Biene-auf-Blume-v1-1040.png 1040w
                "
                src="../assets/images/Biene-auf-Blume-v1-1040.png"
                alt="Nahaufnahme einer Biene auf einer Blume"
              />
            </picture>
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Hero",
  props: {
    claim: String,
    question: String,
    question1: String,
    question2: String,
    question3: String,
    solution: String
  },
  data() {
    return {
      questions: [
        { text: this.question1 },
        { text: this.question2 },
        { text: this.question3 }
      ]
    };
  }
};
</script>

<style lang="scss">
.carousel {
  min-height: auto !important;
}

.heroshout {
  padding-top: 2rem !important;
}

.picturecolumn {
  margin-top: auto !important;
}

.prachtwild {
  padding-right: 0rem !important;
  padding-bottom: 0rem !important;
  padding-top: 0rem !important;
  background: $info;
  background: linear-gradient(90deg, $info 61.5%, $white 38.5%);
}

.questionmark {
  opacity: 0.25;
  width: 120px;
  position: absolute;
  margin-top: -180px;
  svg {
    path {
      fill: $white;
    }
  }
}

.claimbox {
  background-color: $white;
  padding: 0.5rem 1rem;
}

//mobile, mobile image, 380px
@media screen and (max-width: 380px) {
  .heroimage {
    width: 85%;
  }

  .prachtwild {
    background: linear-gradient(90deg, $info 76.5%, $white 23.5%);
  }

  .picturecolumn {
    margin-left: -7px !important;
  }

  .questionmark {
    margin-top: -160px;
    right: -40px;
    svg {
      path {
        fill: $info;
      }
    }
  }
}

//mobile, mobile image, 520px
@media screen and (min-width: 381px) and (max-width: 520px) {
  .heroimage {
    width: 90%;
  }

  .prachtwild {
    background: linear-gradient(90deg, $info 76.5%, $white 23.5%);
  }

  .picturecolumn {
    margin-left: 5px !important;
  }

  .questionmark {
    margin-top: -140px;
    right: -40px;
    svg {
      path {
        fill: $info;
      }
    }
  }
}

//mobile, mobile image, 768px
@media screen and (min-width: 521px) and (max-width: $tablet - 1px) {
  .heroimage {
    width: 80%;
  }

  .prachtwild {
    background: linear-gradient(90deg, $info 79.5%, $white 20.5%);
  }

  .picturecolumn {
    margin-left: 0px !important;
  }

  .questionmark {
    margin-top: -150px;
    right: 27.5%;
    width: 100px;
  }
}

//tablet-only, 1024px
@media screen and (min-width: $tablet) and (max-width: $desktop - 1px) {
  .prachtwild {
    background: linear-gradient(90deg, $info 75.5%, $white 24.5%);
  }

  .picturecolumn {
    margin-left: 5px !important;
  }

  .questionmark {
    right: 39.5%;
  }
}

//desktop-only, 1216px
@media screen and (min-width: $desktop) and (max-width: $widescreen - 1px) {
  .prachtwild {
    background: linear-gradient(90deg, $info 60.5%, $white 39.5%);
  }

  .picturecolumn {
    margin-left: 0px !important;
  }

  .questionmark {
    right: 46.5%;
  }
}

//widescreen-only, 1407px
@media screen and (min-width: $widescreen) and (max-width: $fullhd - 1px) {
  .prachtwild {
    background: linear-gradient(90deg, $info 57%, $white 43%);
  }

  .picturecolumn {
    margin-left: 0px !important;
  }

  .questionmark {
    right: 54.5%;
  }
}

//fullhd, 1920px
@media screen and (min-width: $fullhd) {
  .prachtwild {
    background: linear-gradient(90deg, $info 57%, $white 43%);
  }

  .picturecolumn {
    margin-left: 100px !important;
  }

  .questionmark {
    right: 54.5%;
  }
}
</style>
